/** @format */
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Home from "../Pages/homepage/Index";
import Device from "../Pages/devices";
import History from "../Pages/history";
import Upload from "../Pages/upload";
import MainLayout from "../layout/MainLayout";
import Profile from "../Pages/profile/Profile";
import Rules from "../Pages/rule/Rules";
import AboutUs from "../Pages/about";
import SanadDetail from "../Pages/homepage/listFileSanad/SanadDetail";
import NotFound from "../Pages/NotFound";
import Support from "../Pages/support";
import Chat from "../Pages/chat";
import Ticket from "../Pages/ticket";
import Setting from "../Pages/setting";
import AddLetter from "../Pages/letter/add-letter";
import LetterList from "../Pages/letter/letter-list";
import Adjustment from "../Pages/letter/adjusment";
// Animation variants
const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5 } },
};

const AppRouter = () => {
  const location = useLocation(); // Get the current location for AnimatePresence

  return (
    <AnimatePresence mode="wait">
      {" "}
      {/* Wrap Routes in AnimatePresence */}
      <Routes location={location} key={location.pathname}>
        <Route path="/*" element={<MainLayout />}>
          <Route
            index
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <Home />
              </motion.div>
            }
          />
          <Route
            path="upload"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <Upload />
              </motion.div>
            }
          />
          <Route
            path="profile"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <Profile />
              </motion.div>
            }
          />
          <Route
            path="setting"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <Setting />
              </motion.div>
            }
          />
          <Route
            path="device"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <Device />
              </motion.div>
            }
          />
          <Route
            path="letter"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <LetterList />
              </motion.div>
            }
          />
          <Route
            path="addletter"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <AddLetter />
              </motion.div>
            }
          />

          <Route
            path="history"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <History />
              </motion.div>
            }
          />
          <Route
            path="agreement"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <Rules />
              </motion.div>
            }
          />
          <Route
            path="about"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <AboutUs />
              </motion.div>
            }
          />
          <Route
            path="support"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <Support />
              </motion.div>
            }
          />
          <Route
            path="ticket"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <Ticket />
              </motion.div>
            }
          />

          {/* ///////////////////// */}
          <Route
            path="support/:idstrticket"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <Chat />
              </motion.div>
            }
          />
          {/* ///////////////////// */}

          <Route
            path="sanad/:id"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <SanadDetail />
              </motion.div>
            }
          />
          <Route
            path="adjustment"
            element={
              <motion.div
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={fadeIn}
              >
                <Adjustment />
              </motion.div>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
};

export default AppRouter;
